const initialState = {
  data:{}
};

export default (state = initialState, action = {}) => {
  switch(action.type) {
    case 'FETCH_COMPRIGHTS':
      return {
        ...state,
        data: action.payload
      }
    case 'EDIT_COMPRIGHT':
      if(action.payload.check){
        if (state.data[action.payload.user_id]) {
          return {
            ...state,
            data: {
              ...state.data,
              [action.payload.user_id]: [
                ...state.data[action.payload.user_id],
                action.payload.comp_id
              ]
            }
          }
        }
        else {
          return {
            ...state,
            data: {
              ...state.data,
              [action.payload.user_id]: [action.payload.comp_id]
            }
          }
        }
      }
      else {
        return {
          ...state,
          data: {
            ...state.data,
            [action.payload.user_id]: state.data[action.payload.user_id]
              .filter(id => id !== action.payload.comp_id)
          }
        }
      }
    default: return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/comprights.js